/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { Query } from 'fierry/flux'

import Navigation from 'shared/client/navigation';


export default new Query([ Navigation ], (navigation) =>
{
  return navigation.getCurrent();
});
